
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import {cancelOrder, getOrderDetail, logisticsList, returnOrder} from '@/api/pcm/order';
import { wait } from '@/utils/wait';
import { Message } from 'element-ui';

export default extend(dialog, {
    namespaced: true,
    state: {
		id: 0,
		detail: {},
		list: [],
		logisticsList: [],
		form: {}
    },
    actions: {
        async afterOpenDialog({ dispatch, commit, state }, payload) {
			const { id } = state;
			commit('save', {
				form: {}
			})
            await wait(dispatch, 'pcm.order.return', async function() {
				const response = await getOrderDetail(id);
				if (response.data) {
					commit('save', {
						detail: response.data.purOrderDetailInfo,
						list: response.data.goodsList.map((v) => {
							return {
								...v,
								returnNum: v.suppNum - v.returnedNum,
								returnedReason: 1,
								waitingReturnNum: v.suppNum - v.returnedNum
							}
						})
					})
				}
			})
			await dispatch('getLogisticsList');
		},
		async getLogisticsList({ dispatch, commit, state }) {
			await wait(dispatch, 'pcm.order.getLogisticsList', async function() {
				const response = await logisticsList();
				if (response.data) {
					commit('save', {
						logisticsList: response.data
					})
				}
            })
		},
		async confirm({ dispatch, commit, state }, payload) {
			try {
				const { id, list, form, logisticsList } = state;
				await wait(dispatch, 'pcm.order.shipConfirm', async function() {
					try {
						const response = await returnOrder(id, {
							returnPurGoodsList: payload.map((v) => {
								return {
									returnNum: v.returnNum || 0,
									purGoodsId: v.purOrderGoodsRecId,
									returnedReason: v.returnedReason
								}
							}),
							...form,
							shippingName: form.shippingId && logisticsList.find((logistic) => {
								return logistic.shippingId == form.shippingId
							}).shippingName
						});
						if (response.data) {
							Message.success('退货成功');
							// 关闭弹窗
							dispatch('closeDialog');
							// 重新获取数据
							dispatch('pcmOrderList/getList', {}, {root: true});
						}
					} catch (error) {
						console.error(error)
					}
				})
			} catch (error) {
				console.error(error)
			}
		},
		async cancelOrder({ dispatch, commit, state }, payload){
			await wait(dispatch, 'pcm.order.cancelOrder', async function() {
				const {id: purOrderId } = state
				const response = await cancelOrder({
					purOrderId,
					...payload
				});
				if (response.code === 200) {
					Message.success('释放成功')
					// 关闭弹窗
					dispatch('closeDialog');
					// 重新获取数据
					dispatch('pcmOrderList/getList', {}, {root: true});
				}else{
					Message.success('释放失败')
				}
			})
		}
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/order/return.js